import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  Divider,
  Grid,
  RadioGroup,
  Radio,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Checkbox,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { MdCancel } from "react-icons/md";
import { CiSquarePlus, CiSquareMinus } from "react-icons/ci";
import { Formik, Form, Field } from "formik";
import { AiFillThunderbolt } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
// import "../../Pages/StakeNow/AddToCart/CartPageComponent/Modal/BannerinputGetModal.css";
import "../../../../../Components/ModalCss/BannerinputGetModal.css";

import { IoIosWarning } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
// import actions from "../../../ReduxStore/actions";
import { toast } from "react-toastify";
import CustomInputLogin from "../../../../../Components/CustomInputLogin/CustomInputLogin";
import * as Yup from "yup";

import actions from "../../../../../ReduxStore/actions";
import { clearTableGetId } from "../../../../../ReduxStore/Slices/TableId/TableIdGetSlice";
import { clearCustomerId } from "../../../../../ReduxStore/Slices/Operator/customerSlice";

const RejectCommendModal = ({
  open,
  onClose,
  setGrams,
  resetForm,
  setSubmittedValues,
  submittedValues,
  modalHeadingName,
  handleNextModal,
  values,
  handleSchemeModaClose,
  onSchemeApprovalModalClose
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //   const handleModalConfirm = async() => {

  //     const data1 = {
  //       data: values,
  //       method: "post",
  //       apiName: "addPlan",
  //     };

  //     const responseData = await dispatch(actions.ADDPLANPOST(data1));

  //     if (responseData?.payload?.message === "Plan added successfully.") {
  //       resetForm();
  //       setGrams();
  //       onClose()
  //       handleSchemeModaClose()
  //     }else{
  //       toast.error(responseData?.payload?.message)
  //     }
  //     // onClose();

  //   };

  const TableId = useSelector((state) => state.Table.TableId);


  const { rejectPlan } = useSelector((state) => state?.rejectPlan);

  const SchemeReject = async (values, { resetForm }) => {


    console.log(values, "SchemeRejectSchemeRejectSchemeReject");

    const data1 = {
      data: {
        "reject_comment": values.rejectCommend
      }, method: "put", apiName: `rejectPlan/${TableId}`
    };
    const rejectResponse = await dispatch(actions.REJECTPLAN(data1));

    console.log(rejectResponse.payload.message, "rejectResponse");

    if (rejectResponse.payload.message === "Plan rejected successfully.") {

      toast.success("Plan rejected successfully.")
      setTimeout(() => onClose(), 1500)
      dispatch(clearTableGetId(null))
      dispatch(clearCustomerId(null))


      resetForm()
    }

    if (rejectResponse.payload.message === "This plan is already rejected.") {

      toast.error("This plan is already rejected.")
      setTimeout(() => onClose(), 1500)
    }



  }



  return (
    <Dialog
      open={open}
      //   onClose={onClose}
      fullWidth
      maxWidth="md"
      className="custom-dialog"
      sx={{
        "& .MuiPaper-root": {
          maxWidth: "500px",
          //   borderRadius: "2px",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        {/* <Box className="dialog-heading">
          <IconButton
            aria-label="Close"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
          >
            <MdCancel />
          </IconButton>
          <DialogTitle className="custom-dialog-title">
            <Box>
              <Typography className="custom-title-text" color="white">
                Purchase Document
              </Typography>
            </Box>
          </DialogTitle>
        </Box> */}

        <Formik
          initialValues={{
            rejectCommend: "",
          }}
          validationSchema={Yup.object().shape({

            rejectCommend: Yup.string().required("Reject Commend is required"),
          })}
          onSubmit={(values, { resetForm }) => {
            console.log(values, "Form values submitted");
            onClose()
            onSchemeApprovalModalClose()
            // handleRegisterCompleteOpenModal(); // Open the RegistrationCompleteModal
            // regiterFormSubmitionFn(values, uploadedFiles);
            // handleSubmit();
            // resetForm();
            SchemeReject(values, { resetForm })
          }}
        >
          {({ handleSubmit, setFieldValue, resetForm, values }) => (
            <Form onSubmit={handleSubmit}>
              <DialogContent
                dividers
                sx={{
                  padding: 0,
                  "& .MuiDialogContent-root": {
                    padding: 0,
                  },
                  color: "#7A7A7A",
                  p: { xs: 2, md: "16px 24px" },
                }}
              // sx={{ flexDirection: { xs: "column", md: "row" } }}
              >
                <Grid
                  item
                  sx={{
                    display: "flex",
                    //   justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <IoIosWarning
                      style={{
                        // color: "#eba30a",
                        color: "#C38F51",

                        fontSize: "25px",
                        marginRight: "5px",
                      }}
                    />
                  </Box>
                  <Typography
                    variant="subtitle2"
                    color="black"
                    textAlign="center"
                    sx={{ fontSize: "18px", fontWeight: "500" }}
                  >
                    Are you sure want to reject?
                  </Typography>
                </Grid>
                <Grid item>
                  <Box sx={{ mt: 2, ml: 1 }}>
                    <CustomInputLogin
                      name="rejectCommend"
                      inputType="textarea"
                      custPlaceholder="Enter Reject command"

                    />
                    {/* <Typography>
                 
                      Please confirm if this scheme will be added to the plan,
                      and if any additional changes are needed before proceeding
                    </Typography> */}
                  </Box>
                </Grid>

                <Grid xs={12} mt={2}>
                  <Grid
                    container
                    justifyContent="end"
                    alignItems="center"
                    spacing={2} // Add spacing between buttons
                  >
                    <Grid item>
                      <Button
                        onClick={() => onClose()}
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          color: "white",
                          fontSize: "14px",
                          padding: { xs: "0px 10px", md: "0px 20px" },
                          minHeight: "40px",
                          // borderRadius: "23px",
                          background: "#d5d3d3",
                          boxShadow: "none",
                          color: "black",
                          // border: "1px solid black",
                          // "&:hover": {
                          //   backgroundColor: "#3B4056",
                          //   color: "white",
                          // },
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        type="submit"
                        //   onClick={() => handleModalConfirm()}//
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          color: "white",
                          fontSize: "14px",
                          boxShadow: "none",
                          padding: { xs: "0px 10px", md: "0px 20px" },
                          minHeight: "40px",
                          // borderRadius: "23px",
                          background: "#C38F51 0% 0% no-repeat padding-box",
                          // "&:hover": {
                          //   backgroundColor: "#3B4056",
                          //   boxShadow: "none",
                          // },
                        }}
                      //   disabled={!values.privacyChecked} // Disable button if checkbox is not checked
                      >
                        Confirm
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContent>
            </Form>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
};

export default RejectCommendModal;
